export const staircaseConfig = {
    gameSlug: 'stop-signal',
    category: 'foudre_logique',
    variable: 'duration_ms',
    startValue: 250,
    minValue: 50,
    maxValue: 800,
    stepSizesByPhase: [80, 40, 20, 10],
    reversalsToConverge: 4,
    reversalsForThreshold: 3,
    maxTrials: 40,
    direction: 'up-easier',
};
export const GO_DIRECTIONS = ['left', 'right'];
function buildVariant(level) {
    if (level <= 10) {
        return { level, stopRate: 0.25, responseWindowMs: 1200, label: 'Stop introductif' };
    }
    if (level <= 20) {
        return { level, stopRate: 0.3, responseWindowMs: 1000, label: 'Stop régulier' };
    }
    if (level <= 30) {
        return { level, stopRate: 0.33, responseWindowMs: 900, label: 'Vitesse plus stop' };
    }
    if (level <= 40) {
        return { level, stopRate: 0.37, responseWindowMs: 800, label: 'Pression temporelle' };
    }
    return { level, stopRate: 0.4, responseWindowMs: 700, label: 'Self-control affûté' };
}
export const levels = Array.from({ length: 50 }, (_, i) => buildVariant(i + 1));
export function variantForLevel(level) {
    const idx = Math.max(1, Math.min(50, level)) - 1;
    return levels[idx];
}
export const timing = {
    fixationMs: 400,
    feedbackMs: 500,
    itiMs: 700,
};
export const paradigmMeta = {
    slug: 'stop-signal',
    paradigm: 'Stop-Signal Task (Logan & Cowan 1984)',
    category: 'foudre_logique',
    goal: "Inhibition motrice : annuler une réponse déjà engagée.",
};
//# sourceMappingURL=params.js.map